import React from 'react';
import { observer } from 'mobx-react';
import AddGroupComponent from './Add-group.component';
import useAddGroup from './useAddGroup';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';

const Container: React.FC<ICloseEvent> = ({ onClose }: ICloseEvent) => {
    const { state, store, app, lang, handlers } = useAddGroup(onClose);

    return (
        <>
            <AddGroupComponent
                lang={lang.lang}
                loading={store.createGroupLoading || store.loading}
                groupName={state.groupName}
                groupNameError={state.groupNameError}
                serverError={store.serverError}
                demoModeError={app.demoModeError}
                onGroupNameChange={handlers.handleGroupNameChange}
                onCreateClick={handlers.handleCreateClick}
                onInputClick={handlers.handleInputClick}
                onKeyDown={handlers.handleKeyDown}
                onBtnKeyDown={handlers.handleBtnKeyDown}
                onClose={onClose}
            />
        </>
    );
};

const AddGroupContainer = observer(Container);

export default AddGroupContainer;
